import { forwardRef } from "react";
const SvgTableY = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M4.99989 2L1.5 5.53553M4.99989 2L8.48513 5.53553M4.99989 2V11.0001C4.99989 11.5523 5.4476 12.0001 5.99989 12.0001H13.9999" stroke="currentColor" strokeWidth={2} strokeLinecap="round" /></svg>;
const ForwardRef = forwardRef(SvgTableY);
export default ForwardRef;